import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class RecipesService {

  getRecipes() {
    return axios.get(apiUrl + 'recipes', { headers: authHeader() });
  }

  addRecipe(recipe) {
    return axios.post(apiUrl + 'recipes', recipe, { headers: authHeader() });
  }

  updateRecipe(recipe) {
    return axios.put(apiUrl + 'recipes', recipe, { headers: authHeader() });
  }

  deleteRecipe(id) {
    return axios.delete(apiUrl + 'recipes/' + id, { headers: authHeader() });
  }

}

export default new RecipesService();